import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import Header from "./Header";

import {
  changeLayout,
  changeLeftSidebarTheme,
  changeLeftSidebarType,
  changeTopbarTheme,
  changeBodyThemeType,
} from "../../custom/helpers/Layout";
import {
  activeNavState,
  leftSidebarTypeState,
  themeTypeState,
} from "../../state/GlobalState";
import { useRecoilValue } from "recoil";

const Layout = (props) => {
  const activeNav = useRecoilValue(activeNavState);
  const themeType = useRecoilValue(themeTypeState);

  const [isMobile] = useState(
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  );
  const topbarTheme =
    themeType === "light" || themeType === "dark" ? "dark" : "dark";
  const leftSideBarTheme = "dark";
  const leftSidebarType = useRecoilValue(leftSidebarTypeState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.location.pathname]);

  useEffect(() => {
    document.title = activeNav?.name
      ? activeNav.name + " | " + process.env.REACT_APP_APP_NAME
      : process.env.REACT_APP_APP_NAME;
  }, [activeNav]);

  useEffect(() => {
    changeLeftSidebarTheme(leftSideBarTheme);
    changeTopbarTheme(topbarTheme);
    changeBodyThemeType(themeType);

    if (leftSidebarType) {
      changeLeftSidebarType(leftSidebarType, isMobile);
    }
  }, [leftSidebarType, isMobile, themeType, leftSideBarTheme, topbarTheme]);

  useEffect(() => {
    changeLayout("vertical");
  }, []);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header />
        <div>{props.children}</div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Layout);
